import InfiniteScrollTable from '@app/components/InfiniteScrollTable'
import SearchBar from '@app/components/SearchBar'
import { IContact } from '@app/models/Contact'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { RouteComponentProps } from 'react-router-dom'
import { Column } from 'react-virtualized'
import { actionCreators, IGuestListState } from '../modules/guestList'

type ComponentProps = IGuestListState &
  typeof actionCreators &
  RouteComponentProps<{}>

export default class UsersListPage extends React.PureComponent<ComponentProps> {
  private tableRef: React.RefObject<InfiniteScrollTable>

  constructor(props: ComponentProps) {
    super(props)

    bindFunctions(this)

    this.tableRef = React.createRef<InfiniteScrollTable>()
  }

  public render() {
    return (
      <DocumentTitle title='Admin - Guests'>
        <div className='container d-flex flex-column h-100 pt-3'>
          <div>
            <h3>Guests</h3>
            <SearchBar
              onChange={this._onChangeFilter}
              placeholder='Looking for a certain guest?'
              size='sm'
              value={this.props.filterText}
            />
          </div>
          <div className='mt-4'>
            <InfiniteScrollTable
              isLoading={this.props.isLoading}
              items={this.props.items}
              loadItems={this.props.loadGuest}
              noRowsRenderer={this._noRowsRenderer}
              onRowClicked={this._onRowClicked}
              totalItems={this.props.totalItems}
              ref={this.tableRef}
            >
              <Column
                cellDataGetter={({ rowData }) => {
                  const user = rowData as IContact
                  if (user.firstName) {
                    return `${user.firstName} ${user.lastName}`
                  } else {
                    return user.lastName
                  }
                }}
                dataKey='name'
                flexGrow={1}
                label='Name'
                width={200}
              />
              <Column
                cellDataGetter={({ rowData }) => {
                  const user = rowData as IContact
                  return user.user ? user.user.username : ''
                }}
                dataKey='username'
                flexGrow={1}
                label='Username'
                width={200}
              />
              <Column
                cellDataGetter={({ rowData }) => {
                  const user = rowData as IContact
                  return user.user ? user.user.status : ''
                }}
                dataKey='status'
                label='Status'
                width={100}
              />
            </InfiniteScrollTable>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _noRowsRenderer() {
    return <div>No guests</div>
  }

  private _onRowClicked(item: IContact, index: number) {
    this.props.history.push(`/admin/guest/${item.id}`)
  }

  private _onChangeFilter(newFilter: string) {
    this.props.setFilterText(newFilter)
    this._reloadData()
  }

  private _reloadData() {
    if (this.tableRef.current) {
      this.tableRef.current.forceReloadData()
    }
  }
}
